import React from 'react';
import { connect } from 'react-redux';

import CalculatorForLanding from 'apps/promo/components/calculator/CalculatorForLandingNew';
import { getTotalTariffValueForAmount } from 'apps/promo/components/calculator/CalculatorUtils';
import PromoButtonExtended from 'apps/promo/components/common/promo-button/PromoButtonExtended';
import { PromoDangerouslyHtml } from 'apps/promo/components/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoSectionContainer } from 'apps/promo/components/common/PromoSectionContainer';

import { HeroContainer, HeroContent, HeroSubtitle, HeroTextBlock, HeroTitle } from './styles';

const HeroCalculatorSection = (props) => {
    const { calculatorData } = props;
    const imageCountryCode = calculatorData?.targetCountry;
    const { newTariffs } = calculatorData.transaction;

    const promoAdditionalInfo = props.calculatorData.messages?.promoText;

    const parseText = (title, country, paysystems, fee) => {
        if (!title) {
            return '';
        }

        return title
            .replace('{COUNTRY}', country ?? '')
            .replace('{PAYSYSTEMS}', paysystems ?? '')
            .replace('{FEE}', fee ?? '');
    };

    const bonusSpecialCommission = props.calculatorData.transaction.bonusSpecialCommission;
    const hasBonusSpecialCommission = bonusSpecialCommission !== null;

    const commissionCurrency = props.calculatorData.transaction?.commissionCurrency
        ? props.calculatorData.transaction?.commissionCurrency
        : props.calculatorData.transaction?.currencyToBeDebited;
    const countryName = props.calculatorData.messages?.countryName;
    const paysystem = props.calculatorData.messages?.paysystem;

    const feeAmount =
        getTotalTariffValueForAmount(10, newTariffs.fromTariffList, newTariffs.toTariffList, true)?.commissionAmount + `&nbsp;${commissionCurrency}`;
    const bonusSpecialCommissionAmount = bonusSpecialCommission + `&nbsp;${commissionCurrency}`;

    const title = parseText(props.calculatorData.messages?.title, countryName);
    const subtitle = parseText(
        props.calculatorData.messages?.landingSubtitle,
        countryName,
        paysystem,
        hasBonusSpecialCommission ? bonusSpecialCommissionAmount : feeAmount,
    );

    return (
        <HeroContainer countryToCode={imageCountryCode.toLowerCase()}>
            <PromoSectionContainer>
                <HeroContent>
                    <HeroTextBlock>
                        <HeroTitle>
                            <PromoText tag="h1" variant="h1" color="white">
                                {title}
                            </PromoText>
                        </HeroTitle>

                        <HeroSubtitle>
                            <PromoDangerouslyHtml tag="div" variant="subheader" color="white" dangerouslyHtml={subtitle} />
                        </HeroSubtitle>

                        {promoAdditionalInfo && promoAdditionalInfo !== '' && (
                            <HeroSubtitle secondRow>
                                <PromoDangerouslyHtml color="white" dangerouslyHtml={promoAdditionalInfo} />
                            </HeroSubtitle>
                        )}

                        {props.data?.btn && (
                            <PromoButtonExtended
                                btn={props.data?.btn}
                                btnMobile={props.data?.btn_mobile}
                                isMobileBtn={props.data?.isMobileBtn}
                                variant="tertiary"
                                isInverted
                                iconName="arrow-right"
                            />
                        )}
                    </HeroTextBlock>
                    <div>
                        <CalculatorForLanding />
                    </div>
                </HeroContent>
            </PromoSectionContainer>
        </HeroContainer>
    );
};

const mapStateToProps = ({ app, extra }) => {
    const { calculator: calculatorData, ...landingPageData } = extra.strapiApi;

    return {
        calculatorData,
        landingPageData,
        countryCode: app.country,
        mainMenu: extra.newNoAuthMenu,
        footerMenu: extra.noAuthFooter,
        downloadButtons: extra.downloadButtons,
    };
};

export default connect(mapStateToProps)(HeroCalculatorSection);
